export default {"src":"/au/_next/static/media/weddingplannerpro_inco2.7a9f86b3.svg","height":87,"width":77,"blurWidth":0,"blurHeight":0};